import {
  FormControlLabel,
  Radio,
  Box,
  Slider,
  TextField,
  InputAdornment,
  Icon,
  Checkbox,
  FormControl,
  RadioGroup,
  Typography,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import styles from "./IncomeTaxCalculator.module.css";
import stylesAnime from "./IncomeTaxCalculatorAnimation.module.css";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { PrettoSlider } from "../utilities/Custom-Slider-Button";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    color: "#000",
    "&.Mui-disabled": {
      border: 0,
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const IncomeTaxCalculator = () => {
  const gross = "gross";
  const basicSalary = "basicSalary";
  const employerPf = "employerPf";
  const employerNps = "employerNps";
  const intrestInc = "intrestInc";
  const dividendInc = "dividendInc";
  const winningLotteryInc = "winningLotteryInc";
  const otherInc = "otherInc";
  const fbaInc = "fbaInc";
  const yearlyHomeLoan = "yearlyHomeLoan";
  const hra = "hra";
  const totRent = "totRent";
  const basicDeduction = "basicDeduction";
  const npsDeduction = "npsDeduction";
  const medicalInsDeduction = "medicalInsDeduction";
  const donationDeduction = "donationDeduction";
  const eduLoanDeduction = "eduLoanDeduction";
  const depositDeduction = "depositDeduction";
  const detax = "detax";
  const nps = "nps";
  const InitialValue = {
    ageCheckBox: "Yes",
    isMetroCity: "Yes",
    grossSliderValue: 0,
    grossTFValue: "",
    grossAmt: 0,
    basicSalarySliderValue: 0,
    basicSalaryTFValue: "",
    employerPfSliderValue: 0,
    employerPfTFValue: "",
    employerNpsSliderValue: 0,
    employerNpsTFValue: "",
    intrestIncSliderValue: 0,
    intrestIncTFValue: "",
    dividendIncSliderValue: 0,
    dividendIncTFValue: "",
    winningLotteryIncSliderValue: 0,
    winningLotteryIncTFValue: "",
    otherIncSliderValue: 0,
    otherIncTFValue: "",
    fbaIncSliderValue: 0,
    fbaIncTFValue: "",
    yearlyHomeLoanSliderValue: 0,
    yearlyHomeLoanTFValue: "",
    hraSliderValue: 0,
    hraTFValue: "",
    totRentSliderValue: 0,
    totRentTFValue: "",
    basicDeductionSliderValue: 0,
    basicDeductionTFValue: "",
    npsDeductionSliderValue: 0,
    npsDeductionTFValue: "",
    medicalInsDeductionSliderValue: 0,
    medicalInsDeductionTFValue: "",
    donationDeductionSliderValue: 0,
    donationDeductionTFValue: "",
    eduLoanDeductionSliderValue: 0,
    eduLoanDeductionTFValue: "",
    depositDeductionSliderValue: 0,
    depositDeductionTFValue: "",
    detaxOldRegmeTax: "0",
    oldRegmeTax: "0",
    detaxNewRegmeTax: "0",
    newRegmeTax: "0",
    disableCalculateBtn: true,
    listOfError: [],
    selectedDetaxOptions: [detax],
    hideTaxSaved: true,
  };

  const [pageData, setPageData] = useState(InitialValue);

  const maxSliderValue = 100000000;

  const continueBtnValidationSchema = Yup.object().shape({
    grossAmt: Yup.number().min(1, "Gross amount must be greater than 0"),
    basicSalaryAmt: Yup.number().min(1, "Basic amount must be greater than 0"),
    salaryExceeds: Yup.number().max(
      pageData.grossAmt,
      "Sum of Basic Salary + Employer's Contribution to NPS + Employer's Contribution to PF should not exceed the Gross Salary"
    ),
  });

  const handleContinueBtnValidation = () => {
    setPageData((prev) => ({ ...prev, listOfError: [] }));

    const basicSalAmt = convertStrToNum(pageData.basicSalaryTFValue);
    const addedVal =
      basicSalAmt +
      convertStrToNum(pageData.employerPfTFValue) +
      convertStrToNum(pageData.employerNpsTFValue);
    const data = {
      grossAmt: pageData.grossAmt,
      basicSalaryAmt: basicSalAmt,
      salaryExceeds: addedVal,
    };
    continueBtnValidationSchema
      .validate(data, { abortEarly: false })
      .then(() => {
        console.log("Info: handleContinueBtnValidation() pageData -", pageData);
        setPageData((prev) => ({ ...prev, hideTaxSaved: false }));
        const taxSalaryOldRegime = taxableSalaryOldRegime();
        const taxSalaryNewRegime = taxableSalaryNewRegime();

        calculateTaxWithOutDetax(taxSalaryOldRegime, taxSalaryNewRegime);
        calculateTaxWithDetax(taxSalaryOldRegime, taxSalaryNewRegime);
      })
      .catch((validationErrors) => {
        let listOfError = [];
        validationErrors.inner.forEach((error) => {
          listOfError.push(error.message);
        });
        setPageData((prev) => ({
          ...prev,
          disableCalculateBtn: true,
          listOfError,
        }));
      });
  };

  const handleTapOnDetaxAndNpsValidation = (newOptions) => {
    setPageData((prev) => ({ ...prev, listOfError: [] }));

    const basicSalAmt = convertStrToNum(pageData.basicSalaryTFValue);
    const addedVal =
      basicSalAmt +
      convertStrToNum(pageData.employerPfTFValue) +
      convertStrToNum(pageData.employerNpsTFValue);
    const data = {
      grossAmt: pageData.grossAmt,
      basicSalaryAmt: basicSalAmt,
      salaryExceeds: addedVal,
    };
    continueBtnValidationSchema
      .validate(data, { abortEarly: false })
      .then(() => {
        console.log(
          "Info: handleTapOnDetaxAndNpsValidation() pageData -",
          pageData
        );

        if (newOptions.length) {
          setPageData((prev) => ({
            ...prev,
            selectedDetaxOptions: newOptions,
          }));
        }
      })
      .catch((validationErrors) => {
        let listOfError = [];
        validationErrors.inner.forEach((error) => {
          listOfError.push(error.message);
        });
        setPageData((prev) => ({
          ...prev,
          disableCalculateBtn: true,
          listOfError,
        }));
      });
  };

  const handleDetaxOptionsToggle = (event, newOptions) => {
    handleTapOnDetaxAndNpsValidation(newOptions);
  };

  // Update the input field value when the slider changes
  const handleSliderChange = (event, newValue, type) => {
    console.log("===>handleSliderChange type <===", type);
    switch (type) {
      case gross: {
        const num = convertStrToNum(newValue);
        setPageData((perv) => ({
          ...perv,
          grossSliderValue: newValue,
          grossTFValue: formatCurrency(newValue),
          grossAmt: num,
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case basicSalary: {
        setPageData((perv) => ({
          ...perv,
          basicSalarySliderValue: newValue,
          basicSalaryTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case employerPf: {
        setPageData((perv) => ({
          ...perv,
          employerPfSliderValue: newValue,
          employerPfTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case employerNps: {
        setPageData((perv) => ({
          ...perv,
          employerNpsSliderValue: newValue,
          employerNpsTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case intrestInc: {
        setPageData((perv) => ({
          ...perv,
          intrestIncSliderValue: newValue,
          intrestIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case dividendInc: {
        setPageData((perv) => ({
          ...perv,
          dividendIncSliderValue: newValue,
          dividendIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case winningLotteryInc: {
        setPageData((perv) => ({
          ...perv,
          winningLotteryIncSliderValue: newValue,
          winningLotteryIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case otherInc: {
        setPageData((perv) => ({
          ...perv,
          otherIncSliderValue: newValue,
          otherIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case fbaInc: {
        setPageData((perv) => ({
          ...perv,
          fbaIncSliderValue: newValue,
          fbaIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      case yearlyHomeLoan: {
        setPageData((perv) => ({
          ...perv,
          yearlyHomeLoanSliderValue: newValue,
          yearlyHomeLoanTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case hra: {
        setPageData((perv) => ({
          ...perv,
          hraSliderValue: newValue,
          hraTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case totRent: {
        setPageData((perv) => ({
          ...perv,
          totRentSliderValue: newValue,
          totRentTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case basicDeduction: {
        setPageData((perv) => ({
          ...perv,
          basicDeductionSliderValue: newValue,
          basicDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case npsDeduction: {
        setPageData((perv) => ({
          ...perv,
          npsDeductionSliderValue: newValue,
          npsDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case medicalInsDeduction: {
        setPageData((perv) => ({
          ...perv,
          medicalInsDeductionSliderValue: newValue,
          medicalInsDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      case donationDeduction: {
        setPageData((perv) => ({
          ...perv,
          donationDeductionSliderValue: newValue,
          donationDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case eduLoanDeduction: {
        setPageData((perv) => ({
          ...perv,
          eduLoanDeductionSliderValue: newValue,
          eduLoanDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case depositDeduction: {
        setPageData((perv) => ({
          ...perv,
          depositDeductionSliderValue: newValue,
          depositDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      default: {
        console.log("===> Warning: handleSliderChange switch default<===");
      }
    }

    // Update the input field value
  };

  const handleSliderColorChn = (amt, limit) => {
    if (limit == NaN) {
      return "primary";
    }
    const convertedAmt = convertStrToNum(amt);
    if (convertedAmt > limit) {
      return "secondary";
    } else {
      return "primary";
    }
  };

  // Function to format the number with Indian currency formatter
  const formatCurrency = (value) => {
    if (typeof value === "string") {
      // value = parseFloat(value.replace(/,/g, ""));
      value = parseInt(value.replace(/,/g, ""));
    }

    // Use Math.floor to round down the number to the nearest whole number
    // value = Math.floor(value);
    // console.log("===> Info: value <===", value);
    return value.toLocaleString("en-IN");
  };

  // Update the slider value when the input field changes
  const handleTextFieldChange = (event, type) => {
    // console.log("===>handleTextFieldChange event <===", event);
    console.log("===>handleTextFieldChange type <===", type);

    let newValue = event.target.value.length === 0 ? "0" : event.target.value;

    if (typeof newValue === "string") {
      newValue = parseFloat(newValue.replace(/,/g, ""));
    }

    // console.log("===> Info: new value <===", newValue);

    if (!/^\d*$/.test(newValue)) {
      return;
    }

    switch (type) {
      case gross: {
        const num = convertStrToNum(newValue);
        setPageData((perv) => ({
          ...perv,
          grossSliderValue: newValue,
          grossTFValue: formatCurrency(newValue),
          grossAmt: num,
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case basicSalary: {
        setPageData((perv) => ({
          ...perv,
          basicSalarySliderValue: newValue,
          basicSalaryTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case employerPf: {
        setPageData((perv) => ({
          ...perv,
          employerPfSliderValue: newValue,
          employerPfTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case employerNps: {
        setPageData((perv) => ({
          ...perv,
          employerNpsSliderValue: newValue,
          employerNpsTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case intrestInc: {
        setPageData((perv) => ({
          ...perv,
          intrestIncSliderValue: newValue,
          intrestIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case dividendInc: {
        setPageData((perv) => ({
          ...perv,
          dividendIncSliderValue: newValue,
          dividendIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case winningLotteryInc: {
        setPageData((perv) => ({
          ...perv,
          winningLotteryIncSliderValue: newValue,
          winningLotteryIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case otherInc: {
        setPageData((perv) => ({
          ...perv,
          otherIncSliderValue: newValue,
          otherIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case fbaInc: {
        setPageData((perv) => ({
          ...perv,
          fbaIncSliderValue: newValue,
          fbaIncTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      case yearlyHomeLoan: {
        setPageData((perv) => ({
          ...perv,
          yearlyHomeLoanSliderValue: newValue,
          yearlyHomeLoanTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case hra: {
        setPageData((perv) => ({
          ...perv,
          hraSliderValue: newValue,
          hraTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case totRent: {
        setPageData((perv) => ({
          ...perv,
          totRentSliderValue: newValue,
          totRentTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case basicDeduction: {
        setPageData((perv) => ({
          ...perv,
          basicDeductionSliderValue: newValue,
          basicDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case npsDeduction: {
        setPageData((perv) => ({
          ...perv,
          npsDeductionSliderValue: newValue,
          npsDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case medicalInsDeduction: {
        setPageData((perv) => ({
          ...perv,
          medicalInsDeductionSliderValue: newValue,
          medicalInsDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      case donationDeduction: {
        setPageData((perv) => ({
          ...perv,
          donationDeductionSliderValue: newValue,
          donationDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case eduLoanDeduction: {
        setPageData((perv) => ({
          ...perv,
          eduLoanDeductionSliderValue: newValue,
          eduLoanDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }
      case depositDeduction: {
        setPageData((perv) => ({
          ...perv,
          depositDeductionSliderValue: newValue,
          depositDeductionTFValue: formatCurrency(newValue),
          newRegmeTax: 0,
          oldRegmeTax: 0,
          detaxNewRegmeTax: 0,
          detaxOldRegmeTax: 0,
          disableCalculateBtn: false,
        }));
        break;
      }

      default: {
        console.log("===> Warning: handleTextFieldChange switch default<===");
      }
    }
  };

  const tapOnContinue = () => {
    // additional logic needed -> to cancel the call if field is empty

    handleContinueBtnValidation();
  };

  const convertStrToNum = (value) => {
    if (typeof value === "string") {
      value = parseInt(value.replace(/,/g, ""));
      // console.log("value testing", value ? value : 0);
      return value ? value : 0;
    } else if (typeof value === "number") {
      console.log("value from number - ", value);
      return value;
    }
    return 0;
  };

  const taxableSalaryNewRegime = () => {
    // step - 1
    // SD = Rs.75,000

    const standardDetection = 75000;

    const grossSalary =
      convertStrToNum(pageData.grossTFValue) +
      convertStrToNum(pageData.intrestIncTFValue) +
      convertStrToNum(pageData.dividendIncTFValue) +
      convertStrToNum(pageData.winningLotteryIncTFValue) +
      convertStrToNum(pageData.otherIncTFValue);

    if (grossSalary == NaN) {
      console.log("===> Error: taxableSalaryNewRegime grossSalary is NaN <===");
      return;
    }

    const taxableSalary = grossSalary - standardDetection;

    console.log(
      "===> Info: taxableSalaryNewRegime() taxableSalary <===",
      taxableSalary
    );

    return taxableSalary;
  };

  const taxableSalaryOldRegime = () => {
    // step - 1
    // A = HRA REceived
    // B = (Actual Rent Paid - 10% of BS)
    // C = If user is in metro, 50% of BS, if user is in non metro, 40% of BS

    // Least of A,B,C
    const basicSal = convertStrToNum(pageData.basicSalaryTFValue);
    if (basicSal == NaN) {
      console.log("===> Error: taxableSalaryOldRegime basicSal is NaN <===");
      return;
    }

    const hraReceived = convertStrToNum(pageData.hraTFValue);
    const basicSalary = basicSal * 0.1;
    const hraByCity =
      pageData.isMetroCity == "Yes" ? basicSal * 0.5 : basicSal * 0.4;
    const paidRentInExcess =
      convertStrToNum(pageData.totRentTFValue) - basicSalary;

    if (
      hraReceived == NaN ||
      basicSalary == NaN ||
      hraByCity == NaN ||
      paidRentInExcess == NaN
    ) {
      console.log(
        "===> Error: taxableSalaryOldRegime hraReceived || basicSalary || hraByCity || houseRent is NaN <==="
      );
      return;
    }
    const val = Math.min(hraReceived, paidRentInExcess, hraByCity);

    const rentPaid = val < 0 ? 0 : val;

    // step - 2
    // If user has entered > 2L for Interest paid on HL, consider only 2L. If lesser than 2L, take the actual amount
    const yearlyHomeLoan = convertStrToNum(pageData.yearlyHomeLoanTFValue);

    if (yearlyHomeLoan == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime yearlyHomeLoan is NaN <==="
      );
      return;
    }

    const minAmtHomeLoan = Math.min(yearlyHomeLoan, 200000);

    // step - 3
    // SD = Rs.50,000

    const standardDetection = 50000;

    // step - 4
    // add all deduction with allowable range

    const deduction80CNullable = convertStrToNum(
      pageData.basicDeductionTFValue
    );

    if (deduction80CNullable == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deduction80C is NaN <==="
      );
      return;
    }
    const deduction80C = Math.min(150000, deduction80CNullable);

    console.log(
      "===> Info: taxableSalaryOldRegime deduction80C <===",
      deduction80C
    );

    const deductionNpsNullable = convertStrToNum(pageData.npsDeductionTFValue);

    if (deductionNpsNullable == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deductionNpsNullable is NaN <==="
      );
      return;
    }
    const deductionNps = Math.min(50000, deductionNpsNullable);

    const deductionMedicalInsNullable = convertStrToNum(
      pageData.medicalInsDeductionTFValue
    );

    if (deductionMedicalInsNullable == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deductionMedicalInsNullable is NaN <==="
      );
      return;
    }
    const deductionMedicalIns = Math.min(25000, deductionMedicalInsNullable);

    const deductionDonation =
      convertStrToNum(pageData.donationDeductionTFValue) * 0.5;

    if (deductionDonation == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deductionDonation is NaN <==="
      );
      return;
    }

    const deductionEduLoan = convertStrToNum(pageData.eduLoanDeductionTFValue);

    if (deductionEduLoan == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deductionEduLoan is NaN <==="
      );
      return;
    }

    const deductionDepositNullable = convertStrToNum(
      pageData.depositDeductionTFValue
    );

    if (deductionDepositNullable == NaN) {
      console.log(
        "===> Error: taxableSalaryOldRegime deductionDepositNullable is NaN <==="
      );
      return;
    }
    const deductionDeposit = Math.min(10000, deductionDepositNullable);

    const deduction =
      deduction80C +
      deductionNps +
      deductionMedicalIns +
      deductionDonation +
      deductionEduLoan +
      deductionDeposit;

    // step - 5
    // Taxable Salary = Gross Salary - (Step 1 + Step 2+ Step 3+ Step 4)

    const grossSalary =
      convertStrToNum(pageData.grossTFValue) +
      convertStrToNum(pageData.intrestIncTFValue) +
      convertStrToNum(pageData.dividendIncTFValue) +
      convertStrToNum(pageData.winningLotteryIncTFValue) +
      convertStrToNum(pageData.otherIncTFValue);

    if (grossSalary == NaN) {
      console.log("===> Error: taxableSalaryOldRegime grossSalary is NaN <===");
      return;
    }

    const taxableSalary =
      grossSalary - (rentPaid + standardDetection + minAmtHomeLoan + deduction);

    console.log(
      "Info: taxableSalaryOldRegime() taxableSalary -",
      taxableSalary
    );

    return taxableSalary;
  };

  const empContributionWithDetax = (regimeType) => {
    const basicSal = convertStrToNum(pageData.basicSalaryTFValue);
    if (basicSal == NaN) {
      console.log("===> Error: empContributionWithDetax basicSal is NaN <===");
      return;
    }

    if (typeof regimeType !== "string") {
      console.log("===> Error: regimeType is not present <===");
      return;
    }

    const nps = convertStrToNum(pageData.employerNpsTFValue);
    const pf = convertStrToNum(pageData.employerPfTFValue);
    if (pf == NaN || nps == NaN) {
      console.log("===> Error: empContributionWithDetax pf || nps is NaN <===");
      return;
    }

    const npsPercentage = regimeType === "new" ? 0.14 : 0.1;

    const addNpsAndPf = pageData.selectedDetaxOptions.includes("nps")
      ? Math.min(basicSal * npsPercentage, nps) + pf
      : pf;

    const empContribution = Math.min(addNpsAndPf, 750000);

    console.log(
      "Info: empContributionWithDetax() empContribution",
      empContribution
    );

    return empContribution;
  };

  const empContributionWithoutDetax = () => {
    const basicSal = convertStrToNum(pageData.basicSalaryTFValue);
    if (basicSal == NaN) {
      console.log(
        "===> Error: empContributionWithoutDetax basicSal is NaN <==="
      );
      return;
    }

    const pf = convertStrToNum(pageData.employerPfTFValue);
    if (pf == NaN) {
      console.log("===> Error: empContributionWithoutDetax pf is NaN <===");
      return;
    }

    const empContribution = Math.min(pf, 750000);
    console.log(
      "Info: empContributionWithoutDetax() empContribution -",
      empContribution
    );
    return empContribution;
  };

  const handleDetaxSelection = () => {
    const fba = convertStrToNum(pageData.fbaIncTFValue);
    const nps = convertStrToNum(pageData.npsDeductionTFValue);

    if (fba == NaN || nps == NaN) {
      console.log("Error: handleDetaxSelection() fba || nps is NaN");
      return;
    }

    if (pageData.selectedDetaxOptions.includes(detax)) {
      console.log("Info: handleDetaxSelection() fba -", fba);
      return fba;
    } else {
      console.log("Info: handleDetaxSelection() fba -", 0);
      return 0;
    }
  };

  const calculateTaxWithDetax = (taxSalaryOldRegime, taxSalaryNewRegime) => {
    let taxableSalaryOld =
      taxSalaryOldRegime -
      empContributionWithDetax("old") -
      handleDetaxSelection();

    let taxableSalaryNew =
      taxSalaryNewRegime -
      empContributionWithDetax("new") -
      handleDetaxSelection();

    console.log(
      `===> /ntaxableSalaryNew - ${taxableSalaryNew} /ntaxSalaryNewRegime - ${taxSalaryNewRegime} \nempContributionWithDetax - ${empContributionWithDetax()} \nhandleDetaxSelection - ${handleDetaxSelection()}`
    );

    console.log(
      `Info: calculateTaxWithDetax() \ntaxableSalaryOld - ${taxableSalaryOld} \ntaxableSalaryNew - ${taxableSalaryNew}`
    );

    if (taxableSalaryOldRegime == NaN || taxableSalaryNewRegime == NaN) {
      console.log(
        "===> Info: calculateTaxWithDetax taxableSalaryOldRegime || taxableSalaryNewRegime is NaN <==="
      );
      return;
    }

    const oldRegimeTax = addCessAndSurchageOldRegime(
      taxableSalaryOld,
      calculateTaxForOldRegime(taxableSalaryOld)
    );
    const newRegmeTax = addCessAndSurchageNewRegime(
      taxableSalaryNew,
      calculateTaxForNewRegime(taxableSalaryNew)
    );

    setPageData((prev) => ({
      ...prev,
      detaxNewRegmeTax: newRegmeTax,
      detaxOldRegmeTax: oldRegimeTax,
    }));
  };

  const taxRegimeCessAndSurchage = {
    lessThan50Lac: 1.04,
    between50To100Lac: 1.144,
    between100To200Lac: 1.196,
    between200To500Lac: 1.3,
    above500Lac: 1.4248,
  };

  const addCessAndSurchageOldRegime = (taxableSalary, tax) => {
    if (taxableSalary < 5000000) {
      return tax * taxRegimeCessAndSurchage.lessThan50Lac;
    } else if (taxableSalary >= 5000000 && taxableSalary < 10000000) {
      return tax * taxRegimeCessAndSurchage.between50To100Lac;
    } else if (taxableSalary >= 10000000 && taxableSalary < 20000000) {
      return tax * taxRegimeCessAndSurchage.between100To200Lac;
    } else if (taxableSalary >= 2000000 && taxableSalary < 50000000) {
      return tax * taxRegimeCessAndSurchage.between200To500Lac;
    } else {
      return tax * taxRegimeCessAndSurchage.above500Lac;
    }
  };
  const addCessAndSurchageNewRegime = (taxableSalary, tax) => {
    if (taxableSalary < 5000000) {
      return tax * taxRegimeCessAndSurchage.lessThan50Lac;
    } else if (taxableSalary >= 5000000 && taxableSalary < 10000000) {
      return tax * taxRegimeCessAndSurchage.between50To100Lac;
    } else if (taxableSalary >= 10000000 && taxableSalary < 20000000) {
      return tax * taxRegimeCessAndSurchage.between100To200Lac;
    } else {
      return tax * taxRegimeCessAndSurchage.between200To500Lac;
    }
  };

  const calculateTaxWithOutDetax = (taxSalaryOldRegime, taxSalaryNewRegime) => {
    const taxableSalaryOld = taxSalaryOldRegime - empContributionWithoutDetax();
    const taxableSalaryNew = taxSalaryNewRegime - empContributionWithoutDetax();

    console.log(
      `Info: calculateTaxWithOutDetax() \ntaxableSalaryOld - ${taxableSalaryOld} \ntaxableSalaryNew - ${taxableSalaryNew}`
    );

    if (taxableSalaryOld == NaN || taxableSalaryNew == NaN) {
      console.log("===> Error: NaN calculateTaxWithOutDetax() <===");
      return;
    }
    const oldRegimeTax = addCessAndSurchageOldRegime(
      taxableSalaryOld,
      calculateTaxForOldRegime(taxableSalaryOld)
    );
    const newRegmeTax = addCessAndSurchageNewRegime(
      taxableSalaryNew,
      calculateTaxForNewRegime(taxableSalaryNew)
    );

    setPageData((prev) => ({
      ...prev,
      newRegmeTax: newRegmeTax,
      oldRegmeTax: oldRegimeTax,
    }));
  };

  const calculateTaxForNewRegime = (taxableSalary) => {
    let taxAmt = 0;

    if (!taxableSalary || taxableSalary <= 1200000) {
      return taxAmt;
    }
    if (taxableSalary - 800000 <= 0) {
      const val = (taxableSalary - 400000) * 0.05;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 400000 * 0.05;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 1 -", taxAmt);
    if (taxableSalary - 1200000 <= 0) {
      const val = (taxableSalary - 800000) * 0.1;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 400000 * 0.1;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 2 -", taxAmt);
    if (taxableSalary - 1600000 <= 0) {
      const val = (taxableSalary - 1200000) * 0.15;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 400000 * 0.15;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 3 -", taxAmt);
    if (taxableSalary - 2000000 <= 0) {
      const val = (taxableSalary - 1600000) * 0.2;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 400000 * 0.2;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 4 -", taxAmt);

    if (taxableSalary - 2400000 <= 0) {
      const val = (taxableSalary - 2000000) * 0.25;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 400000 * 0.25;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 5 -", taxAmt);
    if (taxableSalary - 2400000 > 0) {
      taxAmt = taxAmt + (taxableSalary - 2400000) * 0.3;
    }
    console.log("Info: calculateTaxForNewRegime taxAmt - 6 -", taxAmt);

    return Math.round(taxAmt);
  };

  const subractTwoNumber = (a, b) => {
    return convertStrToNum(a) - convertStrToNum(b);
  };

  const isWholeNumber = (num) => {
    return num === Math.round(num);
  };

  const findPercentage = (value, total) => {
    const percentage = (value / total) * 100;
    const handledDecimal = isWholeNumber(percentage)
      ? percentage
      : parseFloat(percentage.toFixed(2));
    return Math.abs(handledDecimal);
  };

  const setTaxSavedPercentage = (withoutDetaxTaxAmt, withDetaxTaxAmt) => {
    // console.log(
    //   "Info: setTaxSavedPercentage withoutDetaxTaxAmt",
    //   withoutDetaxTaxAmt
    // );
    // console.log("Info: setTaxSavedPercentage withDetaxTaxAmt", withDetaxTaxAmt);

    const value = findPercentage(
      subractTwoNumber(withoutDetaxTaxAmt - withDetaxTaxAmt),
      withoutDetaxTaxAmt
    );

    // console.log("Info: setTaxSavedPercentage value", value);

    return value ? value : 0;
  };

  const calculateTaxForOldRegime = (taxableSalary) => {
    let taxAmt = 0;
    if (!taxableSalary) {
      return taxAmt;
    }

    if (taxableSalary - 500000 <= 0) {
      console.log("===> test taxableSalary", taxableSalary);
      let val = (taxableSalary - 250000) * 0.05;
      console.log("===> val", val);
      taxAmt = taxAmt + (val > 0 ? val : 0);
      console.log("===> taxAmt", taxAmt);
    } else {
      taxAmt = taxAmt + 250000 * 0.05;
    }

    console.log("Info: calculateTaxForOldRegime taxAmt - 1 -", taxAmt);

    if (taxableSalary - 1000000 <= 0) {
      const val = (taxableSalary - 500000) * 0.2;
      taxAmt = taxAmt + (val > 0 ? val : 0);
    } else {
      taxAmt = taxAmt + 500000 * 0.2;
    }

    console.log("Info: calculateTaxForOldRegime taxAmt - 2 -", taxAmt);

    if (taxableSalary - 1000000 > 0) {
      taxAmt = taxAmt + (taxableSalary - 1000000) * 0.3;
    }

    console.log("Info: calculateTaxForOldRegime taxAmt - 3 -", taxAmt);
    // if (taxableSalary <= 500000) {
    //   taxAmt = taxAmt + Math.min(250000, taxableSalary - 250000) * 0.05;
    //   // console.log("===> taxAmt-1", taxAmt);
    // }

    // if (taxableSalary <= 1000000) {
    //   taxAmt = taxAmt + Math.min(500000, taxableSalary - 500000) * 0.2;
    //   taxAmt = taxAmt + Math.min(250000, taxableSalary - 250000) * 0.05;
    //   // console.log("===> taxAmt-2", taxAmt);
    // }

    // if (taxableSalary > 1000000) {
    //   taxAmt = taxAmt + Math.min(500000, taxableSalary - 500000) * 0.2;
    //   taxAmt = taxAmt + Math.min(250000, taxableSalary - 250000) * 0.05;
    //   taxAmt = taxAmt + (taxableSalary - 1000000) * 0.3;
    // }

    // return taxAmt;
    return Math.round(taxAmt);
  };

  const handleAgeCategorySelection = (event) => {
    setPageData((perv) => ({ ...perv, ageCheckBox: event?.target?.value }));
  };

  const handleCityTypeSelection = (event) => {
    setPageData((perv) => ({
      ...perv,
      isMetroCity: event?.target?.value,
      newRegmeTax: 0,
      oldRegmeTax: 0,
      detaxNewRegmeTax: 0,
      detaxOldRegmeTax: 0,
    }));
  };

  useEffect(() => {
    console.log("===> Info: pageData.ageCheckBox <===", pageData.ageCheckBox);
  }, [pageData.ageCheckBox]);
  useEffect(() => {
    // additional logic needed to check validation of all fields
    if (pageData.selectedDetaxOptions) {
      const taxSalaryNewRegime = taxableSalaryNewRegime();
      const taxSalaryOldRegime = taxableSalaryOldRegime();
      calculateTaxWithOutDetax(taxSalaryOldRegime, taxSalaryNewRegime);
      calculateTaxWithDetax(taxSalaryOldRegime, taxSalaryNewRegime);
    }
  }, [pageData.selectedDetaxOptions]);

  return (
    <div className={styles.incomeTaxCalculator}>
      <nav className={styles.nav}>
        <img
          className={styles.ncaishLogoFinal1Icon}
          alt=""
          src={`${process.env.REACT_APP_BASE_NAME}/ncaishlogofinal-1@2x.png`}
        />
        <div className={styles.incomeTaxCalculator1}>
          <p>Income Tax Calculator</p>
        </div>
      </nav>
      <main className={styles.main}>
        <div className={styles.div}>
          <p className={styles.loremIpsum}>
            Income tax in India is a direct tax levied by the Central Government
            on Income generated by individuals and businesses in a particular
            financial year. The amount payable for your income tax depends on
            how much money you earn under different heads of income. Tax
            planning is one of the crucial steps that ensures financial wellness
            for an individual. The below calculator helps a salaried individual
            to ascertain the amount of taxes he/she is likely to pay by
            considering the income and their components. The taxes saved by
            adopting De’tax is also shown separately for an individual’s
            understanding. It doesn’t stop here! The user will know which tax
            regime will suit him/her based on the income levels and the various
            components of income.
          </p>
        </div>
        <div className={styles.div1}>
          <div className={styles.div2}>
            {/* <p className={styles.incomeTaxCalculator2}>Income Tax Calculator</p> */}
            <form className={styles.form}>
              <div
                className={`${styles.accordionBody}  ${
                  pageData.hideTaxSaved
                    ? stylesAnime.fixedHeightMinForm
                    : stylesAnime.fixedHeightMaxForm
                }`}
              >
                <div className={styles.accordion}>
                  <div className={stylesAnime.borderBottom}>
                    <Accordion defaultExpanded={true}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={styles.accordionHead}>
                          <div className={styles.titleWrapper}>
                            <p className={styles.title}>Income</p>
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className={`${styles.accordionBody1}`}>
                          <div className={styles.div6}>
                            <div className={styles.subHead}>
                              <div className={styles.titleWrapper}>
                                <p className={styles.title1}>Gross Salary</p>
                              </div>
                            </div>
                            <div className={styles.div6}>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Gross Salary
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.grossSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          gross
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={`${styles.frameChild} ${styles.textAlignRight}`}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.grossTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, gross)
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Basic Salary
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.basicSalarySliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          basicSalary
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.basicSalaryTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, basicSalary)
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Employer's Contribution to PF (if it forms a
                                    part of Gross Salary)
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.employerPfSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          employerPf
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.employerPfTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, employerPf)
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Employer Contribution to NPS
                                  </label>
                                  <Tooltip
                                    title="Employer contributions to the NPS account of an employee are tax-deductible, up to 10% of the basic salary under the old tax regime, and up to 14% under the new tax regime. The tax deduction allowed up to a maximum of 7.5 lakhs including all such contributions made by the employer to the employee’s retirement corpus."
                                    arrow
                                  >
                                    <Icon>
                                      <InfoIcon />
                                    </Icon>
                                  </Tooltip>
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.employerNpsSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          employerNps
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.employerNpsTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, employerNps)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={styles.div6}>
                            <div className={styles.subHead}>
                              <div className={styles.titleWrapper}>
                                <p className={styles.title1}>
                                  Annual Income from other sources
                                </p>
                              </div>
                            </div>
                            <div className={styles.div6}>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Interest Income (includes Savings, FD, RD)
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.intrestIncSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          intrestInc
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.intrestIncTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, intrestInc)
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Dividend Income from shares and MF
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.dividendIncSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          dividendInc
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.dividendIncTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, dividendInc)
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Winning from Lotteries
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={
                                        pageData.winningLotteryIncSliderValue
                                      }
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          winningLotteryInc
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.winningLotteryIncTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(
                                        event,
                                        winningLotteryInc
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Any other income apart from Capital Gains,
                                    Rental Income and Business Income
                                  </label>
                                  <img
                                    className={styles.fluentinfo28RegularIcon}
                                    alt=""
                                  />
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.otherIncSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          otherInc
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.otherIncTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, otherInc)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={styles.div6}>
                            <div className={styles.subHead}>
                              <div className={styles.titleWrapper}>
                                <p className={styles.title1}>
                                  Flexible Benefit Allowance (FBA)
                                </p>
                              </div>
                            </div>
                            <div className={styles.accordionBody}>
                              <div className={styles.accordionBody}>
                                <div className={styles.labelParent}>
                                  <label className={styles.label}>
                                    Flexible Benefit Allowance
                                  </label>
                                  <Tooltip
                                    title="Flexible Benefit Allowances (FBA) refers to certain categories of benefits like Meal, Fuel, Learning & Development, Books & Periodicals, Movable assets, Wellness, Communication allowances etc. which are offered by an employer to enable an employee to save taxes. This is set as a fixed percentage of an employee's salary."
                                    arrow
                                  >
                                    <Icon>
                                      <InfoIcon />
                                    </Icon>
                                  </Tooltip>
                                </div>
                                <div className={styles.sliderParent}>
                                  <Box className={styles.slider}>
                                    <PrettoSlider
                                      color="primary"
                                      orientation="horizontal"
                                      value={pageData.fbaIncSliderValue}
                                      onChange={(event, newValue) =>
                                        handleSliderChange(
                                          event,
                                          newValue,
                                          fbaInc
                                        )
                                      }
                                      max={maxSliderValue}
                                    />
                                  </Box>
                                  <TextField
                                    className={styles.frameChild}
                                    sx={{ width: 150 }}
                                    color="primary"
                                    variant="outlined"
                                    type="text"
                                    InputProps={{
                                      sx: {
                                        "& input": {
                                          textAlign: "right",
                                        },
                                      },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <Icon>
                                            <CurrencyRupeeIcon />
                                          </Icon>
                                        </InputAdornment>
                                      ),
                                    }}
                                    placeholder=""
                                    size="small"
                                    margin="none"
                                    value={pageData.fbaIncTFValue}
                                    onChange={(event) =>
                                      handleTextFieldChange(event, fbaInc)
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  <div className={`${stylesAnime.borderBottom}`}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                      >
                        <div className={styles.accordionHead}>
                          <div className={styles.titleWrapper}>
                            <p className={styles.title}>Exemptions</p>
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className={`${styles.div}`}>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Annual interest paid on home loan
                              </label>
                              <Tooltip
                                title="Interest expenses on home loans is tax deductible up to 2 lakhs."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color={handleSliderColorChn(
                                    pageData.yearlyHomeLoanTFValue,
                                    200000
                                  )}
                                  orientation="horizontal"
                                  value={pageData.yearlyHomeLoanSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      yearlyHomeLoan
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.yearlyHomeLoanTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(event, yearlyHomeLoan)
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.subHead}>
                            <div className={styles.titleWrapper}>
                              <p className={styles.title1}>HRA Exemptions</p>
                            </div>
                          </div>
                          <div className={styles.div6}>
                            <div className={styles.accordionBody}>
                              <div className={styles.labelParent}>
                                <label className={styles.label}>
                                  HRA Received
                                </label>
                                <img
                                  className={styles.fluentinfo28RegularIcon}
                                  alt=""
                                />
                              </div>
                              <div className={styles.sliderParent}>
                                <Box className={styles.slider}>
                                  <PrettoSlider
                                    color="primary"
                                    orientation="horizontal"
                                    value={pageData.hraSliderValue}
                                    onChange={(event, newValue) =>
                                      handleSliderChange(event, newValue, hra)
                                    }
                                    max={maxSliderValue}
                                  />
                                </Box>
                                <TextField
                                  className={styles.frameChild}
                                  sx={{ width: 150 }}
                                  color="primary"
                                  variant="outlined"
                                  type="text"
                                  InputProps={{
                                    sx: {
                                      "& input": {
                                        textAlign: "right",
                                      },
                                    },
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Icon>
                                          <CurrencyRupeeIcon />
                                        </Icon>
                                      </InputAdornment>
                                    ),
                                  }}
                                  placeholder=""
                                  size="small"
                                  margin="none"
                                  value={pageData.hraTFValue}
                                  onChange={(event) =>
                                    handleTextFieldChange(event, hra)
                                  }
                                />
                              </div>
                            </div>
                            <div className={styles.accordionBody}>
                              <div className={styles.labelParent}>
                                <label className={styles.label}>
                                  Total Rent Paid
                                </label>
                                <img
                                  className={styles.fluentinfo28RegularIcon}
                                  alt=""
                                />
                              </div>
                              <div className={styles.sliderParent}>
                                <Box className={styles.slider}>
                                  <PrettoSlider
                                    color="primary"
                                    orientation="horizontal"
                                    value={pageData.totRentSliderValue}
                                    onChange={(event, newValue) =>
                                      handleSliderChange(
                                        event,
                                        newValue,
                                        totRent
                                      )
                                    }
                                    max={maxSliderValue}
                                  />
                                </Box>
                                <TextField
                                  className={styles.frameChild}
                                  sx={{ width: 150 }}
                                  color="primary"
                                  variant="outlined"
                                  type="text"
                                  InputProps={{
                                    sx: {
                                      "& input": {
                                        textAlign: "right",
                                      },
                                    },
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Icon>
                                          <CurrencyRupeeIcon />
                                        </Icon>
                                      </InputAdornment>
                                    ),
                                  }}
                                  placeholder=""
                                  size="small"
                                  margin="none"
                                  value={pageData.totRentTFValue}
                                  onChange={(event) =>
                                    handleTextFieldChange(event, totRent)
                                  }
                                />
                              </div>
                            </div>
                            <div className={styles.div4}>
                              <label className={styles.areYouBelow}>
                                Are you working in a metro city?
                              </label>
                              <div>
                                <FormControl component="fieldset">
                                  <RadioGroup
                                    row
                                    aria-label="radiogroup"
                                    name="radiogroup"
                                    value={pageData.isMetroCity}
                                    onChange={handleCityTypeSelection}
                                  >
                                    <FormControlLabel
                                      value="Yes"
                                      label="Yes"
                                      labelPlacement="end"
                                      control={
                                        <Radio color="primary" size="medium" />
                                      }
                                    />
                                    <FormControlLabel
                                      value="No"
                                      label="No"
                                      labelPlacement="end"
                                      control={
                                        <Radio color="primary" size="medium" />
                                      }
                                    />
                                  </RadioGroup>
                                </FormControl>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  <div className={stylesAnime.borderBottom}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3a-content"
                        id="panel3a-header"
                      >
                        <div className={styles.accordionHead}>
                          <div className={styles.titleWrapper}>
                            <p className={styles.title}>Deductions</p>
                          </div>
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className={`${styles.div6}`}>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Basic Deductions (80C)
                              </label>
                              <Tooltip
                                title="Contributions to Provident fund, PPF, Life insurance, specified mutual fund schemes etc are tax deductible up to 1.5 lakhs."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color={handleSliderColorChn(
                                    pageData.basicDeductionTFValue,
                                    150000
                                  )}
                                  orientation="horizontal"
                                  value={pageData.basicDeductionSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      basicDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.basicDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(event, basicDeduction)
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Contribution to NPS (Self)
                              </label>
                              <Tooltip
                                title="Employee’s contribution to NPS is tax deductible up to 50,000."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color={handleSliderColorChn(
                                    pageData.npsDeductionTFValue,
                                    50000
                                  )}
                                  orientation="horizontal"
                                  value={pageData.npsDeductionSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      npsDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.npsDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(event, npsDeduction)
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Medical Insurance Premium (80D)
                              </label>
                              <Tooltip
                                title="Contributions towards medical insurance premium for self, dependent spouse and children are tax deductible up to 25000."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color={handleSliderColorChn(
                                    pageData.medicalInsDeductionTFValue,
                                    25000
                                  )}
                                  orientation="horizontal"
                                  value={
                                    pageData.medicalInsDeductionSliderValue
                                  }
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      medicalInsDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.medicalInsDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(
                                    event,
                                    medicalInsDeduction
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Donations to charity (80G)
                              </label>
                              <Tooltip
                                title="50% of donations to charity under section 80G is taken as tax deductible."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color="primary"
                                  orientation="horizontal"
                                  value={pageData.donationDeductionSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      donationDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.donationDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(
                                    event,
                                    donationDeduction
                                  )
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Interest on educational loan (80E)
                              </label>
                              <img
                                className={styles.fluentinfo28RegularIcon}
                                alt=""
                              />
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color="primary"
                                  orientation="horizontal"
                                  value={pageData.eduLoanDeductionSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      eduLoanDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.eduLoanDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(event, eduLoanDeduction)
                                }
                              />
                            </div>
                          </div>
                          <div className={styles.accordionBody}>
                            <div className={styles.labelParent}>
                              <label className={styles.label}>
                                Interest on deposits in saving account
                                (80TTA/TTB)
                              </label>
                              <Tooltip
                                title="Tax deduction up to 10000 Rs is provided for interest income from Savings accounts."
                                arrow
                              >
                                <Icon>
                                  <InfoIcon />
                                </Icon>
                              </Tooltip>
                            </div>
                            <div className={styles.sliderParent}>
                              <Box className={styles.slider}>
                                <PrettoSlider
                                  color={handleSliderColorChn(
                                    pageData.depositDeductionTFValue,
                                    10000
                                  )}
                                  orientation="horizontal"
                                  value={pageData.depositDeductionSliderValue}
                                  onChange={(event, newValue) =>
                                    handleSliderChange(
                                      event,
                                      newValue,
                                      depositDeduction
                                    )
                                  }
                                  max={maxSliderValue}
                                />
                              </Box>
                              <TextField
                                className={styles.frameChild}
                                sx={{ width: 150 }}
                                color="primary"
                                variant="outlined"
                                type="text"
                                InputProps={{
                                  sx: {
                                    "& input": {
                                      textAlign: "right",
                                    },
                                  },
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon>
                                        <CurrencyRupeeIcon />
                                      </Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                placeholder=""
                                size="small"
                                margin="none"
                                value={pageData.depositDeductionTFValue}
                                onChange={(event) =>
                                  handleTextFieldChange(event, depositDeduction)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
              <div>
                {pageData.listOfError.map((err) => (
                  <div>
                    <p
                      style={{
                        color: "red",
                        fontSize: "13px",
                        paddingTop: "0px",
                        paddingBottom: "5px",
                      }}
                    >
                      *{`  ${err}`}
                    </p>
                  </div>
                ))}
              </div>
              <button
                disabled={pageData.disableCalculateBtn}
                type="button"
                className={
                  pageData.disableCalculateBtn
                    ? styles.disabledBtn
                    : styles.button
                }
                onClick={tapOnContinue}
                color="primary"
              >
                <div className={styles.calculate}>Calculate</div>
              </button>

              <div>
                <Typography style={{ textAlign: "justify", fontSize: "10px" }}>
                  The above calculator is intended for information purposes
                  only. While sufficient care has been taken in providing the
                  information, Figital Technologies Private limited or any of
                  its employees cannot be held responsible for any
                  errors/omissions. Please contact a tax expert for further
                  clarifications.
                </Typography>
              </div>
            </form>
          </div>
          <div className={styles.div3}>
            <div className={styles.div38}>
              <p className={styles.taxYouPay}>Tax you pay</p>
              <div className={styles.withoutDetax}>
                <div className={styles.div39}>
                  <p className={styles.withoutDetax1}>Without De’tax & Nps</p>
                </div>
                <div className={styles.div40}>
                  <div className={styles.div41}>
                    <p className={styles.p}>{`₹ ${formatCurrency(
                      pageData.oldRegmeTax
                    )}`}</p>
                    <p className={styles.oldTaxRegime}>Old Tax Regime</p>
                  </div>
                  <div className={styles.div41}>
                    <p className={styles.p}>{`₹ ${formatCurrency(
                      pageData.newRegmeTax
                    )}`}</p>
                    <p className={styles.oldTaxRegime}>New Tax Regime</p>
                  </div>
                </div>
              </div>

              <div className={styles.withDetax}>
                <div>
                  <Paper
                    elevation={0}
                    sx={{
                      display: "flex",
                      border: (theme) => `2px solid ${theme.palette.info.dark}`,
                      flexWrap: "wrap",
                    }}
                  >
                    <StyledToggleButtonGroup
                      value={pageData.selectedDetaxOptions}
                      onChange={handleDetaxOptionsToggle}
                      aria-label="tax benifits"
                      // color="info"
                    >
                      <ToggleButton value={detax} aria-label="Fba Allowance">
                        <Typography>De'tax</Typography>
                      </ToggleButton>
                      <ToggleButton value={nps} aria-label="Nps">
                        <Typography>&nbsp;&nbsp;NPS&nbsp;&nbsp;</Typography>
                      </ToggleButton>
                    </StyledToggleButtonGroup>
                  </Paper>
                </div>
                <div className={styles.div43}>
                  <p className={styles.withoutDetax1}>
                    {!pageData.selectedDetaxOptions.includes(detax)
                      ? "With NPS"
                      : !pageData.selectedDetaxOptions.includes(nps)
                      ? "With De'tax"
                      : "With De'tax & With NPS"}
                  </p>
                </div>

                <div className={styles.div44}>
                  <div className={styles.div41}>
                    <p className={styles.p}>{`₹ ${formatCurrency(
                      pageData.detaxOldRegmeTax
                    )}`}</p>
                    <p className={styles.oldTaxRegime}>Old Tax Regime</p>
                  </div>
                  <div className={styles.div41}>
                    <p className={styles.p}>{`₹ ${formatCurrency(
                      pageData.detaxNewRegmeTax
                    )}`}</p>
                    <p className={styles.oldTaxRegime}>New Tax Regime</p>
                  </div>
                </div>
              </div>
              <div>
                <Typography
                  style={{
                    textAlign: "justify",
                    fontSize: "10px",
                  }}
                >
                  The tax amounts indicated above are including cess and
                  surcharge, wherever applicable.
                </Typography>
              </div>
            </div>

            {!pageData.hideTaxSaved && (
              <div className={styles.taxSaveContainer}>
                <div className={styles.taxSave}>
                  <p className={styles.taxYouSave}>Tax you save</p>
                  <div className={styles.amountOfTaxSavedParent}>
                    <p className={styles.taxYouPay}>Amount of tax saved</p>
                    <div className={styles.withDetax2}>
                      <div className={styles.data}>
                        <div className={styles.taxSaved}>
                          <p className={styles.taxSavedAmt}>
                            ₹&nbsp;
                            {formatCurrency(
                              subractTwoNumber(
                                pageData.oldRegmeTax - pageData.detaxOldRegmeTax
                              )
                            )}
                          </p>
                          <p className={styles.taxSavedTitle}>Old Tax Regime</p>
                        </div>
                        <div className={styles.taxSaved}>
                          <p className={styles.taxSavedAmt}>
                            ₹&nbsp;
                            {formatCurrency(
                              subractTwoNumber(
                                pageData.newRegmeTax - pageData.detaxNewRegmeTax
                              )
                            )}
                          </p>
                          <p className={styles.taxSavedPercentTitle}>
                            New Tax Regime
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={styles.amountOfTaxSavedParent}>
                    <p className={styles.taxYouPay}>Percentage of tax saved</p>
                    <div className={styles.withDetax2}>
                      <div className={styles.data}>
                        <div className={styles.taxSaved}>
                          <p className={styles.taxSavedAmt}>
                            {setTaxSavedPercentage(
                              pageData.oldRegmeTax,
                              pageData.detaxOldRegmeTax
                            )}
                            %
                          </p>
                          <p className={styles.taxSavedTitle}>Old Tax Regime</p>
                        </div>
                        <div className={styles.taxSaved}>
                          <p className={styles.taxSavedAmt}>
                            {setTaxSavedPercentage(
                              pageData.newRegmeTax,
                              pageData.detaxNewRegmeTax
                            )}
                            %
                          </p>
                          <p className={styles.taxSavedPercentTitle}>
                            New Tax Regime
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default IncomeTaxCalculator;
